'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _modules = require('redux/modules/modules');

var _reactRouter = require('react-router');

var _goals = require('redux/modules/goals');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POSITIVE = 'Going well';
var NEGATIVE = 'Not going well';
var IDK = 'Don\'t know';

var Module2App8 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module2,
    app: state.moduleData.data.module2.app8,
    goals: state.goals.data,
    strategies: state.goals.data.strategies
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem, updateStrategies: _goals.updateStrategies })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module2App8, _Component);

  function Module2App8() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module2App8);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module2App8.__proto__ || (0, _getPrototypeOf2.default)(Module2App8)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 2,
      appId: 8,
      isCompleted: _this.props.app.isCompleted || false,
      title: 'Program goals',
      progressToGoal: _this.props.app.progressToGoal || '', // how do you think you are progressing towards your goal
      strategies: _this.props.strategies || [{ strategy: '', steps: '', whatIsNeeded: '' }],
      hardcodedStrats: [{
        strategy: 'Have a family meal with no tv',
        add: false
      }, {
        strategy: 'Chop up some vegies and fruit for healthy snacks',
        add: false
      }, {
        strategy: 'Move \'sometimes\' food to a place that my child can\'t reach',
        add: false
      }, {
        strategy: 'Make a rule that my child must ask before taking \'sometimes\' foods',
        add: false
      }, {
        strategy: 'Try the fridge activity',
        add: false
      }, {
        strategy: 'Use the meal planner',
        add: false
      }]
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _this.handleTick = function (index) {
      var obj = _this.state;
      obj.hardcodedStrats[index].add = !obj.hardcodedStrats[index].add;
      _this.setState(obj);
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      _this.setState({ 'showModal': true, isCompleted: true });

      // update the actual app
      _this.props.updateModuleApp(_this.props.user.userId, _this.state.moduleId, _this.state.appId, { 'isCompleted': true, 'progressToGoal': _this.state.progressToGoal });

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      var index = void 0;
      for (index = 0; index < _this.state.hardcodedStrats.length; index++) {
        if (_this.state.hardcodedStrats[index].add) {
          // if the hardcoded strat is added, but was already in our strategies, then we decide
          // to not add it
          var temp = void 0;
          var shouldAdd = true;
          for (temp = 0; temp < _this.state.strategies.length; temp++) {
            if (_this.state.strategies[temp].strategy === _this.state.hardcodedStrats[index].strategy) {
              shouldAdd = false;
              break;
            }
          }
          if (shouldAdd) {
            _this.state.strategies.push({ strategy: _this.state.hardcodedStrats[index].strategy,
              steps: '',
              whatIsNeeded: '' });
          }
        } else {
          // if the hardcoded strategy was already pushed on, but add was false, then we splice it off
          var _temp3 = void 0;
          for (_temp3 = _this.state.strategies.length; _temp3--;) {
            if (_this.state.strategies[_temp3].strategy === _this.state.hardcodedStrats[index].strategy) {
              _this.state.strategies.splice(_temp3, 1);
              break;
            }
          }
        }
      }

      // clean strategies state, iterate backwards
      for (index = _this.state.strategies.length; index--;) {
        if (_this.state.strategies[index].strategy === '') {
          _this.state.strategies.splice(index, 1);
        }
      }

      _this.props.updateStrategies(_this.props.user.userId, _this.state.strategies);
      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Module2App8, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var obj = this.state;
      var index = 0;

      for (index = 0; index < this.state.hardcodedStrats.length; index++) {
        var temp = 0;
        for (temp = 0; temp < this.state.strategies.length; temp++) {
          if (this.state.strategies[temp].strategy === this.state.hardcodedStrats[index].strategy) {
            obj.hardcodedStrats[index].add = true;
          }
        }
      }
      this.state = obj;
    }

    /*
     * General function used to change state of object
     */


    /*
     * Changing checkbox
     */


    /*
     * Handle when user finishes this module
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 2'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'h4',
            null,
            'Your priority goal was to:'
          ),
          _react2.default.createElement(
            'p',
            null,
            'How do you think you are progressing towards this goal?'
          ),
          _react2.default.createElement(
            ReactBootstrap.FormGroup,
            { onChange: this.handleChange.bind(this, 'progressToGoal') },
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'progressToGoal', value: POSITIVE, checked: this.state.progressToGoal === POSITIVE },
              POSITIVE
            ),
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'progressToGoal', value: NEGATIVE, checked: this.state.progressToGoal === NEGATIVE },
              NEGATIVE
            ),
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'progressToGoal', value: IDK, checked: this.state.progressToGoal === IDK },
              IDK
            )
          ),
          this.state.progressToGoal === POSITIVE && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'That\'s great! We hope some of the activities you plan to do over the next week will help towards continuing to achieve or maintain this goal.'
            )
          ),
          this.state.progressToGoal === NEGATIVE && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'That\'s ok. Change can sometimes be a slow process. Don\'t get disheartened, remember it can take up to 20 occasions of providing before a child will accept a new food, especially foods they don\'t like such as vegetables. Can you think of any barriers that might be stopping you from trying out certain strategies? You can record the barriers under the goal setting section by',
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/profile' },
                ' clicking here.'
              )
            )
          ),
          this.state.progressToGoal === IDK && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'That\'s ok. Change can sometimes be a slow process. Can you think of any barriers that might be stopping you from trying out certain strategies?'
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            'Here are your goals, would you like to edit your goals?'
          ),
          _react2.default.createElement(
            ReactBootstrap.FormGroup,
            null,
            _react2.default.createElement(ReactBootstrap.FormControl, { type: 'text', placeholder: 'Set a goal', value: this.props.goals.goals[0], onChange: this.handleChange.bind(this, 0) }),
            _react2.default.createElement('br', null),
            _react2.default.createElement(ReactBootstrap.FormControl, { type: 'text', placeholder: 'Set a goal', value: this.props.goals.goals[1], onChange: this.handleChange.bind(this, 1) }),
            _react2.default.createElement('br', null),
            _react2.default.createElement(ReactBootstrap.FormControl, { type: 'text', placeholder: 'Set a goal', value: this.props.goals.goals[2], onChange: this.handleChange.bind(this, 2) }),
            _react2.default.createElement('br', null)
          ),
          _react2.default.createElement(
            'h3',
            null,
            'Summing up'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Tick which activities you plan to complete this week that you learnt in Module 2'
          ),
          _react2.default.createElement(
            ReactBootstrap.FormGroup,
            null,
            this.state.hardcodedStrats.map(function (item, index) {
              return _react2.default.createElement(
                ReactBootstrap.Checkbox,
                { onChange: function onChange() {
                    _this2.handleTick(index);
                  }, checked: item.add },
                item.strategy
              );
            })
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
          )
        )
      );
    }
  }]);
  return Module2App8;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  allModule: _react.PropTypes.object,
  app: _react.PropTypes.object,
  updateModule: _react.PropTypes.func,
  updateModuleApp: _react.PropTypes.func,
  updateStrategies: _react.PropTypes.func,
  changeItem: _react.PropTypes.func,
  goals: _react.PropTypes.object,
  strategies: _react.PropTypes.array
}, _temp2)) || _class);
exports.default = Module2App8;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/2/App/App8.js
// module id = 1188
// module chunks = 0